import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('swap-request');
const GET_ALL_REQUEST = define('GET_ALL_REQUEST', true);
const GET_SWAP_REQUEST = define('GET_SWAP_REQUEST', true);
const CANCEL_SWAP_REQUEST = define('CANCEL_SWAP_REQUEST', true);

const initialState = {
  isLoading: true,
  swapRequest: {},
  isLoadingList: true,
  list: [],
  processing: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_REQUEST.PENDING:
      return {
        ...state,
        isLoadingList: true
      };
    case GET_ALL_REQUEST.RESOLVED:
      return {
        ...state,
        isLoadingList: false,
        list: action.data
      };
    case GET_SWAP_REQUEST.PENDING:
      return {
        ...state,
        isLoading: true
      };
    case GET_SWAP_REQUEST.RESOLVED:
      return {
        ...state,
        isLoading: false,
        swapRequest: action.data
      };
    case CANCEL_SWAP_REQUEST.PENDING:
      return {
        ...state,
        processing: true
      };
    case CANCEL_SWAP_REQUEST.RESOLVED:
      return {
        ...state,
        processing: false
      };
    default:
      return state;
  }
}

export const actions = {
  getAllSwapRequest: () => ({
    type: GET_ALL_REQUEST,
    promise: api.get('/swap-request'),
    error: 'Unable to load swap request list'
  }),
  getSwapRequest: (id) => ({
    type: GET_SWAP_REQUEST,
    promise: api.get(`/swap-request/${id}`),
    error: 'Unable to load swap request'
  }),
  cancelSwapRequest: (id) => ({
    type: CANCEL_SWAP_REQUEST,
    promise: api.put(`/swap-request/${id}/cancel`),
    success: 'Swap request canceled successfully',
    error: 'Unable to cancel swap request'
  })
};



// WEBPACK FOOTER //
// ./src/ducks/swap-request.js